export const
    MEDIA_TYPE_RESET = 'media_type_reset',
    MEDIA_TYPES_RESET = 'media_types_reset',
    MEDIA_TYPES_PENDING = 'media_types_pending',
    MEDIA_TYPE_FOCUS = 'media_type_focus',
    MEDIA_TYPE_DELETED = 'media_type_deleted',
    MEDIA_TYPE_POSTING = 'media_type_posting',
    MEDIA_TYPE_EDITING = 'media_type_editing',
    MEDIA_TYPE_DELETING = 'media_type_deleting',
    MEDIA_TYPE_FAILED = 'media_type_failed',
    MEDIA_TYPES_FAILED = 'media_types_failed',
    MEDIA_TYPE_DOWNLOADED = 'media_type_downloaded',
    MEDIA_TYPES_DOWNLOADED = 'media_types_downloaded',
    MEDIA_TYPE_PICTURE_UPLOADING = 'media_type_picture_uploading',
    MEDIA_TYPE_PICTURE_FAILED = 'media_type_picture_failed',
    MEDIA_TYPE_PICTURE_UPLOADED = 'media_type_picture_uploaded',
    MEDIA_TYPE_PICTURE_DELETING = 'media_type_picture_deleting';



// WEBPACK FOOTER //
// src/store/mediatypes/types.js